export const categories = [
    "Culture and Free Time",
    "Digital Wellbeing",
    "Make Your Voice Heard",
    "Who are you",
    "Life Skills",
    "Money Matters",
    "Exam Revision",
    "Careers & Options",
    "Relationships"
];


export const careerOptions = [
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    },
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    },
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    },
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    },
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    },
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    },
    {
        title: "The Romans & Celts in Britain",
        year: "Careers & Options . Yr 9",
        category: "Culture and Free Time"
    }
];



 export const groupMapping = {
  1: {
    label: "KS2 Lower",
    options: [
      { value: "3", label: "3" },
      { value: "4", label: "4" },
    ],
  },
  2: {
    label: "KS2 Higher",
    options: [
      { value: "5", label: "5" },
      { value: "6", label: "6" },
    ],
  },
  3: {
    label: "KS3",
    options: [
      { value: "7", label: "7" },
      { value: "8", label: "8" },
      { value: "9", label: "9" },
    ],
  },
  4: {
    label: "KS4",
    options: [
      { value: "10", label: "10" },
      { value: "11", label: "11" },
    ],
  },
  14: {
    label: "College",
    options: [{ value: "14", label: "College" }],
  },
  18: {
    label: "Post-18",
    options: [{ value: "18", label: "Post-18" }],
  },
};



export const  groupData= [


    {"id": 1, "name": "KS2 Lower"},
    {"id": 2, "name": "KS2 Higher"},
    {"id": 3, "name": "KS3"},
    {"id": 4, "name": "KS4"},
    {"id": 14, "name": "College"},
    {"id": 18, "name": "Post-18"},








]



export const  YearData= [
    {"value": 3, "name": "Three"},
    {"value": 4, "name": "Four"},
    {"value": 5, "name": "Five"},
    {"value": 6, "name": "Six"},

    {"value": 7, "name": "Seven"},
    {"value": 8, "name": "Eight"},
    {"value": 9, "name": "Nine"},
    {"value": 10, "name": "Ten"},
    {"value": 11, "name": "Eleven"},
    {"value": 14, "name": "College"},
    {"value": 18, "name": "Post-18"},
]


export const YearDataNew = [

  { id: 1, value: 3, name: "Three" },
  { id: 1, value: 4, name: "Four" },


  { id: 2, value: 5, name: "Five" },
  { id: 2, value: 6, name: "Six" },


  { id: 3, value: 7, name: "Seven" },
  { id: 3, value: 8, name: "Eight" },
  { id: 3, value: 9, name: "Nine" },


  { id: 5, value: 10, name: "Ten" },
  { id: 5, value: 11, name: "Eleven" },


  { id: 14, value: 14, name: "College" },
  { id: 18, value: 18, name: "Post-18" },
];




export const NodataChart = [
    { day: "Monday", hours: 0},
    { day: "Tuesday", hours: 0 },
    { day: "Wednesday", hours: 0 },
    { day: "Thursday", hours: 0 },
    { day: "Friday", hours: 0 },
    { day: "Saturday", hours: 0},
    { day: "Sunday", hours: 0},
  ];


export const issueTypeData = [
    { type: "Login problems" },
    { type: "Account settings errors" },
    { type: "Video playback errors" },
    { type: "Sensitive video" },
    { type: "App crashes or freezes" },
    { type: "Connectivity problems" },
    { type: "General feedback" },
    { type: "Suggestions for improvement" },
    { type: "Other" }
  ];


export const GENDER_TYPE = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
  { value: "Prefer not to say", label: "Prefer Not to Say" },
];
  

export const dropdownGroupsDashboard = [
  {
    group: 1,
    label: "KS2 Lower",
    years: [
      { value: 3, name: "3" },
      { value: 4, name: "4" },
    ],
  },
  {
    group: 2,
    label: "KS2 Higher",
    years: [
      { value: 5, name: "5" },
      { value: 6, name: "6" },
    ],
  },
  {
    group: 3,
    label: "KS3",
    years: [
      { value: 7, name: "7" },
      { value: 8, name: "8" },
      { value: 9, name: "9" },
    ],
  },
  {
    group: 4,
    label: "KS4",
    years: [
      { value: 10, name: "10" },
      { value: 11, name: "11" },
    ],
  },
  {
    group: 14,
    label: "College",
    years: [{ value: 14, name: "14" }],
  },
  {
    group: 18,
    label: "Post-18",
    years: [{ value: 18, name: "18" }],
  },
];
